import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useSelector } from 'react-redux';
import { getSearchValue } from '../../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import { formattedNumber } from '../../licenseAnalyticsSupport/calculationsUtils';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const Row: React.FC<any> = React.memo(({ index, selectedRow, setSelectedRow, clubData }:any) => {
  let totalExpense = 0;
  clubData?.expense?.forEach((exp:any) => {
    totalExpense += exp.total;
  });
  let totalIncome = 0;
  clubData?.income?.forEach((inc:any) => {
    totalIncome += inc.total;
  });
  return (
    <TableRow
      hover
      selected={index === selectedRow ? true : false}
      onClick={() => {
        setSelectedRow(index);
      }}
    >
      <TableCell>
        <ClubNameCell clubData={clubData} />
      </TableCell>
      <TableCell>{formattedNumber(totalExpense)}</TableCell>
      <TableCell>{formattedNumber(totalIncome)}</TableCell>
    </TableRow>
  );
});
Row.propTypes = {
  index: PropTypes.number,
  selectedRow: PropTypes.number,
  setSelectedRow: PropTypes.func,
  clubData: PropTypes.object,
};

const AcademyTableComponent: React.FC = React.memo(({ selectedRow, setSelectedRow, academyClubs }:any) => {
  const searchValue = useSelector(getSearchValue);

  const [objectList, setObjectList] = useState(academyClubs);
  const [isAscending, setIsAscending] = useState(false);

  const handleSortClick = () => {
    const sortedList = [...objectList].sort((a, b) => {
      const nameA = a.club.name.toLowerCase();
      const nameB = b.club.name.toLowerCase();

      if (isAscending) {
        return nameA?.localeCompare(nameB);
      } else {
        return nameB?.localeCompare(nameA);
      }
    });

    setObjectList(sortedList);
    setIsAscending(!isAscending);
  };
  useEffect(() => {
    if (searchValue != '') {
      const filteredList = academyClubs.filter((item:any) =>
        item.club.name.toLowerCase().includes(searchValue.toLowerCase()),
      );
      setObjectList(filteredList);
    } else {
      setObjectList(academyClubs);
    }
  }, [searchValue, academyClubs]);
  return (
    <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
      <Table stickyHeader aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: 'bold' }}>
              CLUB{' '}
              {isAscending ? (
                <ArrowDropUpIcon onClick={handleSortClick} />
              ) : (
                <ArrowDropDownIcon onClick={handleSortClick} />
              )}
            </TableCell>
            <TableCell style={{ fontWeight: 'bold' }}>EXPENSE</TableCell>
            <TableCell style={{ fontWeight: 'bold' }}>INCOME</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {objectList.map((club:any, index:any) => {
            return (
              <Row
                key={index}
                index={index}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                clubData={club}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
});
export default AcademyTableComponent;

export const ClubNameCell:any = React.memo(
  ({ clubData, getClubName = (data:any) => data?.club?.name, getImageUrl = (data:any) => data?.club?.imagePath }:any) => {
    // TODO: After testing revert this to window location instead of hard coded jamp url
    // const baseUrl = `${window.location.protocol}//${window.location.host}/`;
    const baseUrl = 'https://jamp.football/';
    return (
      <div style={{ display: 'flex', alignItems: 'center', padding: '2px' }}>
        <img
          style={{ minHeight: '32px', maxHeight: '32px', display: 'block', paddingTop: '3px', paddingBottom: '3px' }}
          src={baseUrl + 'Content' + getImageUrl(clubData)}
        />
        <div style={{ padding: 5, fontFamily: 'Montserrat', margin: '0 5px' }}>{getClubName(clubData)}</div>
      </div>
    );
  },
);
